import * as React from 'react'
import styled from 'styled-components'
import {
  ConfiguratorBox,
  HighlightInBox
} from 'src/components/containers/configurator/ConfiguratorBox'
import Link from 'src/components/atoms/input/buttons/Link'
import IconText from 'src/components/atoms/IconText'
import { inject, observer } from 'mobx-react'
import { StoreProps } from 'src/stores'
import Loading from 'src/components/atoms/Loading'
import { withRouter } from 'react-router'

const mailIcon = require('src/assets/envelope.png')
const whatsappIcon = require('src/assets/whatsapp.png')

interface Props extends StoreProps {
  history: any
  location: any
  match: any
}

interface State {
  loading: boolean
}

@inject('confStore')
@observer
export class AppointmentConfirmation extends React.Component<Props, State> {
  constructor(props) {
    super(props)
    this.state = { loading: true }
  }

  componentDidMount() {
    const { confStore, history, match } = this.props
    if (!confStore.isOfferLoaded) {
      history.push(`/planung/vorsorge/bestaetigung/${match.params.uuid}`)
    } else {
      setTimeout(() => {
        this.setState({ loading: false })
      }, 1500)
    }
  }

  loading = () => {
    return (
      <ConfiguratorBox title='Lädt ...'>
        <Loading />
      </ConfiguratorBox>
    )
  }

  confirmation = () => {
    const { confStore } = this.props
    const offer = confStore.getOffer
    const greeting =
      offer.contactDetails.greeting === 'MR'
        ? 'Sehr geehrter Herr '
        : 'Sehr geehrte Frau '
    return (
      <ConfiguratorBox title='Vielen Dank!'>
        <p>
          {greeting} {offer.contactDetails.lastName},
        </p>
        <p>
          vielen Dank für Ihre Terminanfrage für einen Beratungstermin zur
          Bestattungsvorsorge. Wir werden uns in kürze an Sie wenden und den
          Termin bestätigen.
        </p>
        <p>
          Wir freuen uns auf das Gespräch mit Ihnen und werden uns bemühen, ein
          auf Ihre Bedürfnisse zugeschnittenes Vorsorgepaket mit Ihnen zu
          erarbeiten.
        </p>
        <p>
          Sollten Sie in der Zwischenzeit Fragen haben, wenden Sie sich
          jederzeit ganz einfach an uns:
        </p>
        <div
          style={{
            display: 'flex',
            flexWrap: 'wrap',
            justifyContent: 'space-evenly'
          }}>
          <IconText icon={mailIcon}>
            <a href='mailto:kontakt@benu.at'>E-Mail an kontakt@benu.at</a>
          </IconText>
          <IconText icon={whatsappIcon}>
            <a
              href={`https://wa.me/43800884404?text=Meine%20Vollmacht%20zum%20Angebot%20"${offer.orderId}"`}
              target='_blank'>
              WhatsApp an 0800884404
            </a>
          </IconText>
        </div>
        <HighlightInBox>
          <p>
            <strong>Alles erledigt?</strong>
          </p>
          <CustomP>
            Kehren Sie zurück zu Ihrer{' '}
            <a href={`/planung/detailplanung/${offer.uuid}`}>Vorsorgeplanung</a>, um
            Änderungen durchzuführen, oder um diese zu erweitern.{' '}
          </CustomP>
          <CustomP>
            Oder informieren Sie sich in unserem Ratgeber zu weiteren Themen
            rund um die Vorsorge wie{' '}
            <a
              href='https://www.benu.at/ratgeber/bestattungsvorsorge/patientenverfuegung/'
              target='_blank'>
              Partientenverfügung
            </a>{' '}
            oder{' '}
            <a
              href='https://www.benu.at/ratgeber/erben/testament/'
              target='_blank'>
              Testament
            </a>
            . Gerne beraten wir Sie auch zu diesen Themen.
          </CustomP>
          <ToRatgeber to='/ratgeber/' target='_blank' light>
            Zum Ratgeber
          </ToRatgeber>
        </HighlightInBox>
      </ConfiguratorBox>
    )
  }

  render() {
    const { loading } = this.state
    return loading ? this.loading() : this.confirmation()
  }
}

const CustomP = styled.p`
  a {
    color: unset;
    text-decoration: underline;
    &:hover {
      color: unset;
    }
  }
`

const ToRatgeber = styled(Link)`
  margin: 7.5px auto;
  padding: 7.5px;
`

export default withRouter(AppointmentConfirmation)



// WEBPACK FOOTER //
// ./src/components/organisms/checkout/AppointmentConfirmation.tsx